import { defineStore } from "pinia";
const useWindowsStore = defineStore("windows", {
  state: () => ({
    chartsTabIndex: 2, // K线图 分时图 显示什么类型 1分时 2日K 3周K 4月K 5年K 6:1分 7:5分 8:15分 9:30分 10:60分 12:季K
    windowList: [
      {Index: "MA", Modify: false, Change: false, Close: false, MaxMin: false, TitleWindow: false, IsDrawTitleBG: true, IsShowNameArrow: true, IndexHelp: true},
      {Index: "VOL", Modify: false, Change: false, Close: false, MaxMin: false, TitleWindow: false, IsDrawTitleBG: true, IsShowNameArrow: true, IndexHelp: true},
      {Index: "MACD", Modify: false, Change: false, Close: false, MaxMin: false, TitleWindow: false, IsDrawTitleBG: true, IsShowNameArrow: true, IndexHelp: true}
    ],
    KRight: 1, // 复权激活id 0不复权 1前复权 2后复权
    ExtendName: "", // 扩展图形名称 StockChipPhone手机端筹码分布
  }),
  getters: {
    getWindowList () {
      return this.windowList;
    },
    getKRight () {
      return this.KRight;
    },
    getExtendName () {
      return this.ExtendName;
    }
  },
  actions: {
    setWindowList (list) {
      this.windowList = list;
    },
    setExtendName (name) {
      this.ExtendName = name;
    },
    setKRight (right) {
      this.KRight = right;
    },
    setChartsTabIndex (index) {
      this.chartsTabIndex = index;
    }
  },
  // 持久化存储插件其他配置
  persist: {
    // 修改存储中使用的键名称，默认为当前 Store的 id
    key: "SET_WINDOW_INFO",
    // 修改为 sessionStorage，默认为 localStorage
    storage: localStorage,
    // 部分持久化状态的点符号路径数组，[]意味着没有状态被持久化(默认为undefined，持久化整个状态)
    paths: ["windowList", "KRight", "ExtendName"]
  }
});
export default useWindowsStore;
